// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ccFhYlN34sMg2N7xzoOB{grid-template-columns:1fr 1fr;gap:12px;margin-top:26px;display:grid}.fu89688pWv4UXh9I_5YF{gap:20px;margin-top:20px;display:grid}.o39WVSMCDbAlCXwwQ7Vi{height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapDropdowns": `ccFhYlN34sMg2N7xzoOB`,
	"wrapCards": `fu89688pWv4UXh9I_5YF`,
	"select": `o39WVSMCDbAlCXwwQ7Vi`
};
export default ___CSS_LOADER_EXPORT___;
